/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Prize_NoneInputs */



/**
* | output |
* | --- |
* | "No prize" |
*
* @param {Raffle_Prize_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_prize_none = /** @type {((inputs?: Raffle_Prize_NoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Prize_NoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas de prix")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin premio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem prêmio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun premio")
	return /** @type {LocalizedString} */ ("No prize")
});